/**
 * Mensagens padronizadas para validação de Business Partner (SAP)
 * 
 * Centraliza todas as mensagens relacionadas à validação de tomadores PJ
 * para facilitar manutenção e garantir consistência.
 */

export const BUSINESS_PARTNER_MESSAGES = {
    /**
     * Mensagem exibida quando ocorre erro ao consultar o Business Partner no SAP
     * (Erro de sistema, timeout, etc)
     */
    QUERY_ERROR: {
        title: 'Falha ao consultar tomador PJ',
        description: 'Não foi possível verificar o cadastro do tomador no sistema.',
        duration: 5,
    },

    /**
     * Mensagem exibida quando o tomador não está cadastrado no SAP
     * (Retorno false da API)
     */
    NOT_FOUND: {
        title: 'CNPJ não encontrado.',
        description: 'O cadastro está em análise devido à possível retenção de impostos. Por favor, tente novamente após 30 minutos ou aguarde a confirmação de um de nossos especialistas.',
        duration: 8,
    },

    /**
     * Mensagem exibida quando múltiplos itens possuem tomador não cadastrado
     */
    NOT_FOUND_MULTIPLE: {
        title: 'CNPJs não encontrados.',
        getDescription: (itemIds: number[]) => 
            `Os cadastros estão em análise devido à possível retenção de impostos. Por favor, tente novamente após 30 minutos ou aguarde a confirmação de um de nossos especialistas, IDs: ${itemIds.join(', ')}. `,
        duration: 8,
    },
} as const;

/**
 * Helper para exibir mensagem de erro de consulta
 */
export const getQueryErrorMessage = () => ({
    message: BUSINESS_PARTNER_MESSAGES.QUERY_ERROR.title,
    description: BUSINESS_PARTNER_MESSAGES.QUERY_ERROR.description,
    duration: BUSINESS_PARTNER_MESSAGES.QUERY_ERROR.duration,
});

/**
 * Helper para exibir mensagem de tomador não encontrado
 */
export const getNotFoundMessage = (itemIds?: number[], totalSelected?: number) => {
    if (itemIds && totalSelected && totalSelected > 1) {
        return {
            message: BUSINESS_PARTNER_MESSAGES.NOT_FOUND_MULTIPLE.title,
            description: BUSINESS_PARTNER_MESSAGES.NOT_FOUND_MULTIPLE.getDescription(itemIds),
            duration: BUSINESS_PARTNER_MESSAGES.NOT_FOUND_MULTIPLE.duration,
        };
    }

    return {
        message: BUSINESS_PARTNER_MESSAGES.NOT_FOUND.title,
        description: BUSINESS_PARTNER_MESSAGES.NOT_FOUND.description,
        duration: BUSINESS_PARTNER_MESSAGES.NOT_FOUND.duration,
    };
};

